import { IconProps } from 'types/icon.type'

export const DashboardIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Dashboard icon</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 3.75C4.36193 3.75 4.25 3.86193 4.25 4V11C4.25 11.1381 4.36193 11.25 4.5 11.25H9.5C9.63807 11.25 9.75 11.1381 9.75 11V4C9.75 3.86193 9.63807 3.75 9.5 3.75H4.5ZM2.75 4C2.75 3.0335 3.5335 2.25 4.5 2.25H9.5C10.4665 2.25 11.25 3.0335 11.25 4V11C11.25 11.9665 10.4665 12.75 9.5 12.75H4.5C3.5335 12.75 2.75 11.9665 2.75 11V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 3.75C15.3619 3.75 15.25 3.86193 15.25 4V7C15.25 7.13807 15.3619 7.25 15.5 7.25H20.5C20.6381 7.25 20.75 7.13807 20.75 7V4C20.75 3.86193 20.6381 3.75 20.5 3.75H15.5ZM13.75 4C13.75 3.0335 14.5335 2.25 15.5 2.25H20.5C21.4665 2.25 22.25 3.0335 22.25 4V7C22.25 7.9665 21.4665 8.75 20.5 8.75H15.5C14.5335 8.75 13.75 7.9665 13.75 7V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 12.75C15.3619 12.75 15.25 12.8619 15.25 13V20C15.25 20.1381 15.3619 20.25 15.5 20.25H20.5C20.6381 20.25 20.75 20.1381 20.75 20V13C20.75 12.8619 20.6381 12.75 20.5 12.75H15.5ZM13.75 13C13.75 12.0335 14.5335 11.25 15.5 11.25H20.5C21.4665 11.25 22.25 12.0335 22.25 13V20C22.25 20.9665 21.4665 21.75 20.5 21.75H15.5C14.5335 21.75 13.75 20.9665 13.75 20V13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 16.75C4.36193 16.75 4.25 16.8619 4.25 17V20C4.25 20.1381 4.36193 20.25 4.5 20.25H9.5C9.63807 20.25 9.75 20.1381 9.75 20V17C9.75 16.8619 9.63807 16.75 9.5 16.75H4.5ZM2.75 17C2.75 16.0335 3.5335 15.25 4.5 15.25H9.5C10.4665 15.25 11.25 16.0335 11.25 17V20C11.25 20.9665 10.4665 21.75 9.5 21.75H4.5C3.5335 21.75 2.75 20.9665 2.75 20V17Z"
        fill="currentColor"
      />
    </svg>
  )
}
